import { TextLanguage, TranslatedText } from "Store/texts/interfaces";

import { Movables } from "../constants";

export const getMovableOptions = (
  options: Array<{ label: TranslatedText; value: Movables }>,
  lang: TextLanguage,
): Array<{
  label: string;
  value: string;
}> =>
  options.map(({ label, value }) => ({
    label: label[lang],
    value,
  }));
